/**
 * Header component functionality
 * Handles mobile menu toggle and other header interactions
 */

export const initHeader = (): void => {
  const mobileMenuButton = document.getElementById("mobile-menu-button");
  const mobileMenu = document.getElementById("mobile-menu");

  if (mobileMenuButton && mobileMenu) {
    mobileMenuButton.addEventListener("click", () => {
      mobileMenu.classList.toggle("hidden");
    });
  }

  const headerContainer = document.querySelector(
    ".header-container",
  ) as HTMLElement;

  if (headerContainer && window.innerWidth >= 1024) {
    let lastScroll = 0;

    const handleScroll = () => {
      const currentScroll =
        window.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll > 32) {
        headerContainer.classList.add("is-stuck");
      } else {
        headerContainer.classList.remove("is-stuck");
      }

      lastScroll = currentScroll;
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
  }
};

export default initHeader;
